/*
 * @Description: Description
 * @Author: ranli
 * @Date: 2023-05-18 17:58:19
 * @LastEditTime: 2026-04-16 16:40:23
 * @LastEditors: ranli
 */
import request from '@/utils/request'
// 获取用户数据
export function getUserInfo(data) {
  return request({
    url: '/api/v1/cricket/user/getUserInfo',
    method: 'post',
    data,
    needFullLoading: true,
  })
  // return request({
  //   url: '/sso/thirdLogin',
  //   method: 'post',
  //   data,
  //   needFullLoading: true,
  //   noAuth: true,
  // })
}

// 获取banner列表
export function getBannerList(data) {
  return request({
    url: '/api/v1/cricket/banner/list',
    method: 'post',
    data,
  })
}
// 获取比赛列表
export function getMatchList(data) {
  return request({
    url: '/api/v1/cricket/match/list',
    method: 'post',
    data,
  })
}
// 获取比赛详情
export function getMatchDetail(data) {
  return request({
    url: '/api/v1/cricket/match/info',
    method: 'post',
    data,
  })
}
// 获取我的参赛记录
export function getMyMatches(data) {
  return request({
    url: '/api/v1/cricket/match/myMatches',
    method: 'post',
    data,
  })
}

// 获取房间列表
export function getRoomList(data) {
  return request({
    url: '/api/v1/cricket/room/list',
    method: 'post',
    data,
  })
}

// 获取房间详情
export function getRoomDetail(data) {
  return request({
    url: '/api/v1/cricket/room/detail',
    method: 'post',
    data,
    needFullLoading: true,
  })
}

// 报名
export function joinRoom(data) {
  return request({
    url: '/api/v1/cricket/room/register',
    method: 'post',
    data,
    needFullLoading: true,
  })
}

// 获取我的房间参赛记录
export function getMyRegistrationRecord(data) {
  return request({
    url: '/api/v1/cricket/room/registration/record',
    method: 'post',
    data,
  })
}

// 获取房间奖池列表
export function getPrizeListByRoomId(data) {
  return request({
    url: '/api/v1/cricket/room/getPrizeListByRoomId',
    method: 'post',
    data,
  })
}
